var _ellipse, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGuides = function SvgGuides(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 70,
    fill: "none"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5,
    cy: 35.1,
    fill: "#EFF4EF",
    rx: 35.511,
    ry: 34.636
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    clipPath: "url(#guides_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.5 29.25 20.704-9.723V51.13L36.5 61.664 15.796 51.13V19.527L36.5 29.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.426 16.285 36.5 24.39l-15.926-8.104M36.5 29.25v32.414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "guides_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 15.475h43v47H15z"
  })))));
};
export { SvgGuides as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzMiIGhlaWdodD0iNzAiIHZpZXdCb3g9IjAgMCA3MyA3MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZWxsaXBzZSBjeD0iMzYuNSIgY3k9IjM1LjEiIHJ4PSIzNS41MTEiIHJ5PSIzNC42MzYiIGZpbGw9IiNFRkY0RUYiLz4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDApIiBzdHJva2U9IiMwMDAiIHN0cm9rZVdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgICA8cGF0aCBkPSJNMzYuNSAyOS4yNWwyMC43MDQtOS43MjNWNTEuMTNMMzYuNSA2MS42NjQgMTUuNzk2IDUxLjEzVjE5LjUyN0wzNi41IDI5LjI1eiIvPgogICAgPHBhdGggZD0iTTUyLjQyNiAxNi4yODVMMzYuNSAyNC4zOWwtMTUuOTI2LTguMTA0TTM2LjUgMjkuMjV2MzIuNDE0Ii8+CiAgPC9nPgogIDxkZWZzPgogICAgPGNsaXBQYXRoIGlkPSJjbGlwMCI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNSAxNS40NzVoNDN2NDdIMTV6Ii8+CiAgICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KPC9zdmc+Cg==";